/* ============================================================
   WESTYN ATHLETIC DEPT. — theme.js
   ============================================================ */

(function () {
  'use strict';

  /* ── HEADER SCROLL ── */
  var header = document.getElementById('SiteHeader');
  function onScroll() {
    if (window.scrollY > 40) header.classList.add('scrolled');
    else header.classList.remove('scrolled');
  }
  if (header) { window.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }

  /* ── HAMBURGER / MOBILE MENU ── */
  var hamburgerBtn = document.getElementById('HamburgerBtn');
  var mobileMenu   = document.getElementById('MobileMenu');

  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    mobileMenu.style.maxHeight = '0';
    mobileMenu.style.height    = '0';
    mobileMenu.style.padding   = '0';
    hamburgerBtn && hamburgerBtn.classList.remove('active');
    hamburgerBtn && hamburgerBtn.setAttribute('aria-expanded', 'false');
    mobileMenu.setAttribute('aria-hidden', 'true');
    /* Re-hide after transition */
    setTimeout(function() {
      if (!mobileMenu.classList.contains('open')) {
        mobileMenu.style.visibility = 'hidden';
      }
    }, 400);
  }

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.style.visibility = 'visible';
    /* Force reflow before adding class */
    void mobileMenu.offsetHeight;
    mobileMenu.classList.add('open');
    mobileMenu.style.maxHeight = '90dvh';
    mobileMenu.style.height    = 'auto';
    mobileMenu.style.padding   = '20px 24px 28px';
    hamburgerBtn && hamburgerBtn.classList.add('active');
    hamburgerBtn && hamburgerBtn.setAttribute('aria-expanded', 'true');
    mobileMenu.setAttribute('aria-hidden', 'false');
  }

  if (hamburgerBtn && mobileMenu) {
    /* Ensure hidden on load */
    mobileMenu.style.visibility = 'hidden';

    hamburgerBtn.addEventListener('click', function () {
      mobileMenu.classList.contains('open') ? closeMenu() : openMenu();
    });

    /* Close on nav link click */
    mobileMenu.querySelectorAll('.mobile-nav-link').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    /* Close on outside click */
    document.addEventListener('click', function (e) {
      if (mobileMenu.classList.contains('open') && !header.contains(e.target)) closeMenu();
    });

    /* Close on Escape */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('open')) closeMenu();
    });
  }

  /* ── SCROLL REVEAL ── */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length > 0) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('visible'); revealObserver.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ── HERO PARALLAX ── */
  var heroBg = document.querySelector('.hero-bg');
  if (heroBg) {
    window.addEventListener('scroll', function () {
      var s = window.scrollY;
      if (s < window.innerHeight) heroBg.style.transform = 'scale(1.02) translateY(' + (s * 0.18) + 'px)';
    }, { passive: true });
  }

  /* ── NEWSLETTER FORM ── */
  var newsletterForm = document.getElementById('HeroNewsletterForm');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function () {
      var btn = newsletterForm.querySelector('.newsletter-btn');
      if (btn) { btn.textContent = '...'; btn.disabled = true; }
    });
  }

  /* ── SMOOTH ANCHORS ── */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

})();
